<ion-content class="theme-{{userService.theme}}">
    <ion-header>
        <app-header [backRoute]="['/home']"></app-header>
    </ion-header>
    <div class="learning-wrap page-width-and-shadow" [@enter]>
        <div class="content-wrap">
            <div class="box">
                <div class="my-color-blue">{{'__ELEARNING_ELEARNING__' | translate}}</div>
                <app-inline-svg class="icon" [file]="'assets/img/footer/monitor.svg'"></app-inline-svg>
            </div>

            <div class="title">{{'__ELEARNING_SELECT_COURSE_FOR_MORE_DETAILS__' | translate}}</div>

            <hr>

            <ng-container *ngIf="pageDate !== null">
                <div class="item" *ngFor="let item of pageDate; let i = index "
                     [routerLink]="['/e-learning/report', item.id]"
                     [@leave]>
                    <div class="i-title">{{item.program.title}}</div>

                    <div class="line">
                        <div class="green">{{'__ELEARNING_AVAILABLE_FROM__' | translate}}</div>
                        {{item.program.availableFrom}}</div>
                    <div class="line">
                        <div class="red">{{'__ELEARNING_COMPLETED_BY__' | translate}}</div>
                        {{item.program.completedBy}}</div>

                    <div class="group">
                        <div class="el">
                            <div class="small-text">{{ "__ELEARNING_STATUS__" | translate }}</div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) >= 0" class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) < 0"
                                 class="text result-{{item.result.resultClass}}">{{item.result.status === 'Completed' ? 'Completed' : 'Incomplete'}}</div>
                        </div>
                        <div *ngIf="false">
                        <div class="el">
                            <div class="small-text">{{'__ELEARNING_RESULT__' | translate}}</div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) >= 0" class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) < 0"
                                 class="text result-{{item.result.resultClass}}">{{item.result.result}}</div>
                        </div>
                        <div class="el">
                            <div class="small-text">{{'__ELEARNING_SCORE__' | translate}}</div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) >= 0" class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) < 0"
                                 class="text">{{item.result.score}}</div>
                        </div>
                        <div class="el">
                            <div class="small-text">{{'__ELEARNING_PASS__' | translate}}</div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) >= 0" class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) < 0"
                                 class="text">{{item.result.pass}}</div>
                        </div>
                        <div class="el">
                            <div class="small-text">{{'__ELEARNING_ATTEMPTS__' | translate}}</div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) >= 0" class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div *ngIf="eDelegateIdsUpdated.indexOf(item.id) < 0"
                                 class="text">{{item.result.attempt}}</div>
                        </div>
                        <div class="el">
                            <div class="small-text">{{'__ELEARNING_MAX__' | translate}}</div>
                            <div class="text">{{item.program.max}}</div>
                        </div>
                        </div>
                    </div>
                    <hr>
                </div>
            </ng-container>

            <ng-container *ngIf="pageDate === null">
                <div class="item" *ngFor="let item of [1,2,3]">
                    <div class="i-title">
                        <ion-skeleton-text animated style="width: 60%; height: 1.7rem;"></ion-skeleton-text>
                    </div>

                    <div class="line">
                        <ion-skeleton-text animated style="width: 45%"></ion-skeleton-text>
                    </div>
                    <div class="line">
                        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                    </div>

                    <div class="group">
                        <div class="el">
                            <div class="small-text" style="width: 3rem;">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                        </div>
                        <div *ngIf="false">
                        <div class="el">
                            <div class="small-text" style="width: 3rem;">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                        </div>
                        <div class="el">
                            <div class="small-text" style="width: 3rem;">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                        </div>
                        <div class="el">
                            <div class="small-text" style="width: 3rem;">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                        </div>
                        <div class="el">
                            <div class="small-text" style="width: 3rem;">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                            <div class="text">
                                <ion-skeleton-text animated></ion-skeleton-text>
                            </div>
                        </div>
                        </div>
                    </div>
                    <hr>
                </div>
            </ng-container>
        </div>
    </div>
</ion-content>
